import { useCallback } from 'react';

import { Address } from '@this+that/models';
import log from 'loglevel';

import {
  searchContacts as searchRemoteContacts,
  userContactToAddress,
} from '../services/contacts.service';

export const useEmailContacts = () => {
  const searchContacts = useCallback(
    async (query: string): Promise<Address[]> => {
      if (!query.trim()) {
        return [];
      }

      try {
        const remoteResults = await searchRemoteContacts({
          input: query,
          requireEmail: true,
        });
        return remoteResults
          .map(userContactToAddress)
          .filter((addr): addr is Address => addr !== null);
      } catch (error) {
        log.error('Remote contact search failed:', error);
        return [];
      }
    },
    [],
  );

  return {
    searchContacts,
  };
};
